import { parkingSplitApi } from '../apiBase';
export var emailApi = parkingSplitApi.injectEndpoints({
    overrideExisting: true,
    endpoints: function (builder) { return ({
        postEmail: builder.mutation({
            query: function (_a) {
                var emailApiBaseUrl = _a.emailApiBaseUrl, regionId = _a.regionId, requestData = _a.requestData;
                return ({
                    url: "".concat(emailApiBaseUrl).concat(regionId),
                    method: 'POST',
                    body: requestData,
                    invalidates: ['Posts'],
                });
            },
        }),
    }); },
});
export var usePostEmailMutation = emailApi.usePostEmailMutation;
